import { AbstractControl, ValidatorFn } from '@angular/forms';

export function requiredTrueValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return !control.value ? {requiredTrue: true} : null;
  };
}
